import React from 'react';
import { createRoot } from 'react-dom/client';
import Root from './root';

const rootElement = document.getElementById('app');
const root = createRoot(rootElement);

root.render(<Root />);
